import React from 'react'
// import SideBarNav from '../../../../Layout/SideBarNav/SideBarNav';

import { Box} from '@mui/material';
import { Container } from '@mui/material';
// TextField
// import Grid from '@mui/material/Grid';
// import FormControl from '@mui/material/FormControl';
// import Input from '@mui/material/Input';
// import InputLabel from '@mui/material/InputLabel';
// import Button from '@mui/material/Button';

import AddBankEEForm from '../Components/AddBankEEForm';



export default function AddBankEmployeePage() {

   // WILL NEED A USEEFFECT TO GO AND GET ALL THE Bank COMPANIES TO FILL IN THE SELECT DROPDOWN...
  // THE Bank COMPANY WILL NEED THE NAME AND THE ID AS WELL.
  // THE ID WILL GO IN THE OBJECT FOR THE EMPLOYEE
  return (
    <Box>
        <Container>
          <AddBankEEForm/>
        </Container>
    </Box>
  )
}
